﻿
$(document).ready(function () {

    // init HomePage hero carousel...
    if (jQuery().slick && $('.homepage-carousel-slide-wrapper')) {

        // attach an initialise event to remove the style attributes hiding any slide contentent
        $('.homepage-carousel-slide-wrapper').on('init', function (e, s) {
            $('.homepage-carousel__slide:not(:first)').removeAttr('style');
        })

        // instance the carousel
        $('.homepage-carousel-slide-wrapper').slick({
            autoplay: true,
            autoplaySpeed: 5500,
            speed: 300,
            arrows: false,
            dots: true,
            appendDots: $('.homepage-carousel'),
            dotsClass: 'carousel-dots',
            customPaging: function (slider, i) {
                return '<a href="#" class="carousel-dot"></a>';
            },
            pauseOnHover: false,
            pauseOnFocus: false
        });
    }
})